import { Box, Button, Text } from '@rbilabs/universal-components';

import Trophy from 'components/icons/trophy';
import { theme } from 'styles/configure-theme';
import { primitive } from 'styles/constants/primitives';

export const QuestCallToAction = Button.withConfig({
  backgroundColor: primitive.bk.$flamingOrange,
  _text: {
    color: theme.token('text-button-primary-reversed'),
  },
});

export const QuestBadgeWrapper = Box.withConfig({
  backgroundColor: theme.token('background-pattern'),
});

export const QuestBadgeIcon = Trophy.withConfig({
  height: '$3',
});

export const QuestBadgeText = Text;

export const ImageWrapper = Box.withConfig({
  height: '$48',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.token('background-default'),
});

export const ReloadButton = Button.withConfig({
  variant: 'outline',
  borderColor: theme.token('border-color-error'),
  _text: {
    variant: 'copyTwo',
    fontSize: 'sm',
    color: theme.token('text-error'),
  },
});
